import { API } from '../../providers/ApiInterceptorProvider';
import { BrokerOnboarding } from './types';

export const brokerApi = {
  getOnboarding: async (): Promise<BrokerOnboarding> => {
    const { data } = await API.get<BrokerOnboarding>(`/monolith/broker/onboarding`);
    return data;
  },
};
